export const API_ENDPOINT = "http://localhost:8000";
export const HAS_FIREBASE = true;
export const GOOGLE_OAUTH_CLIENT_ID = "556935955800-9drqj3evddq0gu5csemfa2o7n86fijcg.apps.googleusercontent.com"

export * as CF from "./cf.js"